export class PublicViewTemplate {
  static DEFAULT = "Featured";
  static FEATURED = "Featured";
  static BILLBOARD = "Billboard";
  static SPLIT = "Split";
  static CATEGORIES_CAROUSEL = "Categories & Carousel";
  static LEFT_NAV_HERO_IMAGE = "Poster";
  static GALLERY = "Gallery";
};
